/**
 * Storage migration utility to clean up old localStorage data
 * Run this once on app load to migrate from client-side workspace storage
 * to backend-only AppWorkspace architecture
 */

export function migrateLocalStorage() {
  // Remove old workspace localStorage
  localStorage.removeItem("mcp-inspector-workspaces");

  // Clean up mcp-inspector-state to only contain UI selections
  const oldState = localStorage.getItem("mcp-inspector-state");
  if (oldState) {
    try {
      const parsed = JSON.parse(oldState);
      const newState = {
        selectedServer: parsed.selectedServer || "none",
        selectedMultipleServers: parsed.selectedMultipleServers || [],
        isMultiSelectMode: parsed.isMultiSelectMode || false,
      };
      localStorage.setItem("mcp-inspector-state", JSON.stringify(newState));
    } catch (e) {
      console.error("Failed to migrate storage", e);
    }
  }
}
